export default __webpack_public_path__ + "static/media/PAYU_LOGO_LIME.7efb9fe4.png";